function getSampleIdsForProject (projectId, sampleCollectionId) {
  if (!this.samples) return
  const samples = this.getSamplesForProject(projectId, sampleCollectionId)
  return samples.map(({ id }) => id)
}

export default getSampleIdsForProject